import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id F5AFD529-AD6F-4A1B-AB69-E3E10FD0E654
 * name pan-bottom-left
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pan-bottom-left.svg
 * tags
 */
export const PanBottomLeftIcon = createSvgIcon(<><path d="M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M5.35,13L11,18.65L5,19L5.35,13Z" /></>, 'PanBottomLeftIcon');
export default PanBottomLeftIcon